<div class="modal-header">
  <h3 class="modal-title">IPSAT 2.0 Report Not Available</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p *ngIf="firstName">
    {{ firstName }} hasn't generated an IPSAT 2.0 Archetype Report yet.
  </p>
  <p *ngIf="!firstName">
    An IPSAT 2.0 Archetype Report has not been generated for this user yet.
  </p>
  <p class="text-muted">
    Open the user's Survey Results to unlock and generate one.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="close()">Close</button>
</div>
